
export const navbarLinks = [
  {
    title: "Home",
    path: "/",
  },
  // {
  //   title: "About",
  //   path: "/about",
  // },
  // {
  //   title: "Contact Us",
  //   path: "/contact",
  // },

];
